import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Maximize Your Business Potential with{" "}
              <span>Android App Development</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Android application development is an effective tool for companies
              to target a large consumer base, increase efficiency, and boost
              sales. Normally, the Android ecosystem provides a higher degree of
              flexibility and compatibility due to the various options.
            </p>
            <p>
              Therefore, it enhances the production of customized solutions that
              suit individual companies’ needs while enhancing user experiences.
              As an agile and innovative platform, Android app development helps
              businesses navigate the dynamic technological landscape and seize
              growth opportunities.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Increased Visibility and Reach</h6>
                <p>
                  Take advantage of the Android platform and reach as many
                  customers as possible on various gadgets and interfaces.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Direct Customer Engagement</h6>
                <p>
                  Create fun experiences that cater to the use of mobile
                  applications to help customers connect better with a company.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Improved Efficiency & Productivity</h6>
                <p>
                  Simplify business operations and improve productivity by
                  creating purpose-built Android apps for various departments.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Google Services Integration</h6>
                <p>
                  Leverage the smooth integration of the surrounding Google
                  services, including Google Maps, Google Pay, and Google Play
                  Services to improve your app.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Scalability & Flexibility</h6>
                <p>
                  Android platform’s architecture is developed through
                  open-source software which facilitates scalability and
                  responds well to shifting organizational needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Future-Proof Investment</h6>
                <p>
                  The Android platform is dynamic therefore your investment in
                  the production of an app will always be productive in the
                  future as the market expands.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
